
import { Vue, Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ShopGoodsInfoDto, getActivityGoodsList, getActivityDtlGoodsList } from '@/api/industryMall'
import { getIsAfterTime } from '@/utils/util'
import scroll from '@/mixins/scroll'
import ActivityGoodsCard from '@/views/industryMall/shop/template/ActivityGoodsCard.vue'
import CountDown from '@/views/industryMall/shop/template/countDown.vue'
import dayjs from 'dayjs'

@Component({
  name: 'Activity',
  components: { ActivityGoodsCard, CountDown }
})
export default class Activity extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter partnerCompanyId!: string
  @Getter topSafetyHeight!: number
  goodsList: ShopGoodsInfoDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 20,
    keyword: '', // 搜索关键字
    activityId: '', // 活动编号
    categoryId: '',
    companyId: '',
    partnerCompanyId: '' // 合作方企业编号
  }
  showSearch = false // 显示搜索
  refreshing = false
  loading = false
  finished = false

  activityCategoryList: Array<any> = [] // 分类列表
  activityData: any = {}
  isStart = '0' // 活动是否开始
  showData = {
    isAfterAdvance: false, // 是否过了提前展示时间
    isAfterBegin: false // 是否过了开始时间
  }
  countDownTime = ''
  isActivated = false

  created () {
    this.isStart = this.$route.query.isStart as string
    if (this.$route.query.isStart === '1') {
      this.params.categoryId = this.$route.query.categoryId as string || '-1'
      this.params.activityId = this.$route.query.activityId as string
      this.params.companyId = this.companyId
      this.params.partnerCompanyId = this.partnerCompanyId
      console.log('this.params.categoryId ***', this.params.categoryId, typeof this.params.categoryId)
      this.getActivityInfo(true)
      this.getGoodsList()
    }
  }

  mounted() {
    this.$addScrollListener('.activity-refresh')
  }

  activated () {
    if (this.isActivated) {
      this.$setScrollY()
    } else {
      this.isActivated = true
    }
  }

  deactivated () {
    this.$removeScrollListener()
  }

  goBack() {
    this.$router.back()
  }

  // 倒计时结束
  endFn() {
    this.getActivityInfo()
    this.reloadList()
  }

  // 获取活动分类及详情
  getActivityInfo (isInit = false) {
    getActivityGoodsList({ activityId: this.params.activityId }).then(res => {
      const allItem = { categoryId: '-1', categoryName: '全部商品' }
      if (isInit) this.activityCategoryList = [allItem, ...res.data[0].categoryList]
      this.activityData = res.data[0]
      // 是否提前展示
      this.showData = getIsAfterTime(this.activityData)
      if (this.activityData.timeType) { // 自定义时间段
        if (this.showData.isAfterAdvance && !this.showData.isAfterBegin) { // 距离开始时间
          this.countDownTime = this.activityData.beginTime
        } else if (this.showData.isAfterBegin) { // 距离结束时间
          this.countDownTime = this.activityData.closeTime
        }
      } else { // 每天时间段
        if (this.showData.isAfterAdvance && !this.showData.isAfterBegin) {
          this.countDownTime = `${dayjs().format('YYYY-MM-DD')} ${this.activityData.startTime}`
        } else if (this.showData.isAfterBegin) {
          this.countDownTime = `${dayjs().format('YYYY-MM-DD')} ${this.activityData.endTime}`
        }
      }
    })
  }

  // 分类点击
  categoryClick (id: string) {
    if (this.params.categoryId !== id) {
      this.params.categoryId = id
      this.reloadList()
    }
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    console.log('onRefresh ***')
    this.params.pageIndex = 1
    this.refreshing = true
    this.getGoodsList()
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.loading = true
    this.params.pageIndex++
    this.getGoodsList()
  }

  /**
   * 获取商品列表
   */
  getGoodsList() {
    const categoryId = this.params.categoryId === '-1' ? '' : this.params.categoryId
    getActivityDtlGoodsList({ ...this.params, categoryId })
      .then((res) => {
        if (this.refreshing || this.loading) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.refreshing = false
        this.loading = false
      })
  }

  onSearch () {
    this.reloadList()
    if (this.$getScrollY() > 80) {
      this.showSearch = false
    }
  }

    /**
   * 去历史记录页
   */
  toHistory() {
    this.$router.push({
      path: '/MallSearchHistory',
      query: {
        searchType: '3',
        activityId: this.$route.query.activityId,
        storeId: this.partnerCompanyId,
        from: 'activity'
      }
    })
  }

  reloadList() {
    this.params.pageIndex = 1
    this.loading = true
    this.getGoodsList()
  }

  onShowSearch () {
    this.toHistory()
  }
}
